import { IdentityDialogOptions, IdentityDialogResult } from '@treasury/domain/shared';
import { OmegaDialogExitReason } from '@treasury/omega/services/omega-dialog';

export const defaultDialogOptions: Omit<IdentityDialogOptions, 'otpRequestFn'> = {
    disableClose: false,
    forLogin: false,
    withoutUserInteraction: false,
};

/**
 * Exists to decouple the auth fetch code from having a dependency
 * on `@treasury/omega`.  Even though the values are the same/similar,
 * this mapping must occur to maintain the constrain that `@treasury/domain`
 * cannot depend on `@treasury/omega`.
 */
export function mapExitReason(reason: OmegaDialogExitReason): IdentityDialogResult['reason'] {
    switch (reason) {
        case OmegaDialogExitReason.Confirm:
            return 'confirm';
        case OmegaDialogExitReason.Cancel:
            return 'cancel';
        default:
            throw new Error(`Invalid identity dialog exit reason ${reason}.`);
    }
}
